export default __webpack_public_path__ + "9e138496e8f1719c6ebf0abe50563635.ttf";